<template>
  <div class="full-wrapper">
    <div class="associate-hero franchise-hero">
      <div class="a-hero-text text-center pt-5">
        <div class="container-fluid px-0">
          <h1 class="secondary-color font-bold">Franchise</h1>
          <h3 class="px-5 main-heading-1">
            Partner with the best in the industry
          </h3>
          <h5 class="font-weight-bold">
            "Aliff winner of Asia’s most prestigious franchise award 2023"
          </h5>s

          <section
            class="container-fluid pb-xl-5 mb-5 gradient-box"
            style="border-radius: 0px; display: block; box-shadow: none"
            id="form_section"
          >
            <div class="row align-items-center justify-content-center">
              <div
                class="col-lg-7 custom_overflow"
                data-aos="fade-right"
                data-aos-duration="600"
              >
                <!-- custom_background_image -->

                <div
                  class="image_container"
                  data-aos="fade-up"
                  data-aos-duration="600"
                >
                  <img
                    src="../../assets/imgs/franchise-hero.png"
                    class="img-fluid custom_fran_image_section_class"
                    alt=""
                  />
                  <div class="centered">
                    By Mr. Amit Kumar Ghosh, IAS, Additional Secretary, Ministry
                    of RT&A, Leela Hotel, Delhi
                  </div>
                </div>
              </div>

              <div
                class="col-lg-5 form_wrapper responsive_margin"
                data-aos="fade-left"
                data-aos-duration="600"
                style="
                  border-radius: 10px;
                  background-color: #fff;
                  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
                "
              >
                <form @submit.prevent="handleSubmit">
                  <div class="custom-form-control my-2">
                    <div class="form-spacing text-left">
                      <label>Name:</label>
                      <input
                        size="sm"
                        required
                        v-model="form.name"
                        placeholder="Enter Name *"
                        class="form-control"
                      />
                    </div>

                    <div class="form-spacing text-left">
                      <label>Email:</label>
                      <input
                        required
                        size="sm"
                        v-model="form.email"
                        placeholder="Enter Email Address *"
                        class="form-control"
                      />
                    </div>

                    <div class="form-spacing text-left">
                      <label>Phone Number:</label>
                      <input
                        required
                        size="sm"
                        v-model="form.mobileNumber"
                        placeholder="Enter Mobile Number *"
                        class="form-control"
                      />
                    </div>
                    <div class="form-spacing text-left">
                      <label>Select State:</label>
                      <b-form-select
                        required
                        size="sm"
                        v-model="form.state"
                        placeholder="Please Select Your State"
                        :options="stateOptions()"
                        class="form-control"
                        @change="geCityOptions()"
                      ></b-form-select>
                    </div>
                    <!-- <b-form-select
                required
                size="sm"
                v-model="form.state"
                :options="stateOptions"
                class="form-control"
              ></b-form-select> -->
                    <div class="form-spacing text-left">
                      <label>Select City:</label>
                      <b-form-select
                        required
                        size="sm"
                        placeholder="Please Select Your City"
                        v-model="form.city"
                        :disabled="form.state ? false : true"
                        :options="cityOptions"
                        class="form-control"
                      ></b-form-select>
                    </div>
                    <!-- <b-form-select
                required
                size="sm"
                v-model="form.city"
                :options="cityOptions"
                class="form-control"
              ></b-form-select> -->

                    <div class="w-100 pt-4 pb-3 d-flex justify-content-start">
                      <button
                        type="submit"
                        class="btn rounded w-50"
                        style="background-color: #fe6d01; color: white"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>

          <!-- <div class="position-relative">
            <img
              src="../../assets/imgs/franchise-hero.png"
              alt=""
              class="my-3 img-fluid"
            />
            <div class="img-text top-0 end-0">
              <h4 class="mb-0">
                “By Mr. Amit Kumar Ghosh, IAS, Additional Secretary, Ministry of
                RT&A, Leela Hotel, Delhi”
              </h4>
            </div>
          </div> -->
        </div>
      </div>

      <!--Video Slider-->

      <section class="masthead hero-text-section">
        <div class="container-fluid px-0">
          <div class="hero-section">
            <div class="hero-section-container">
              <div class="content-area d-none">
                <!-- <h1 class="title">PLUG IN. PLAY YOUR FAVOURITE STREAM</h1> -->
                <h1 class="title">
                  Kickstart your dream of studying abroad with us.
                </h1>
                <!-- <p class="para">
                Your dream of studying abroad awaits you! Let’s kickstart it
                together, right now. Make us a part of your journey and let’s
                rock it!
              </p> -->
                <p class="para">We make global education affordable.</p>
                <a href="#search-home" class="hero-cta">get started</a>
              </div>
              <div class="video-area">
                <center>
                  <video autoPlay loop controls muted>
                    <source
                      src="@/assets/Franchise_Promo_Ad(1080p).mp4"
                      type="video/mp4"
                    />
                    Your browser does not support HTML video.
                  </video>
                </center>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-spacing">
        <div class="container">
          <div
            class="books-wrapper d-flex justify-content-center justify-content-lg-between align-items-center flex-column flex-lg-row"
          >
            <div
              class="text-center text-lg-left col-md-9"
              data-aos="fade-right"
              data-aos-duration="600"
            >
              <h2 class="main-heading-1-gradient text-center text-lg-left">
                About Aliff
              </h2>
              <!-- <h4>Aliff USP</h4> -->
              <!-- <p class="font-weight-bold" style="font-size: 20px;">
                Aliff brings studying abroad within the common man's reach
              </p> -->
              <p>
                Aliff, established in 2008, has offices across India, UAE,
                Kuwait & the USA . Aliff has a counselling experience of 23k+
                students. Our visa success ratio has been 98%. Aliff students
                have received scholarships of worth Rs 32+ Crore (US$ 3.7+
                million) to study at prestigious universities.
              </p>
              <img
                src="../../assets/imgs/google-img.png"
                alt=""
                class="py-3 py-lg-0 review_img"
                data-aos="fade-left"
                data-aos-duration="600"
              />
            </div>
            <div class="col-md-3 responsive_alifnment_img">
              <!-- <img
                src="../../assets/imgs/a-books.png"
                alt=""
                class="img-fluid"
              /> -->
              <img
                src="../../assets/imgs/line_new.svg"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="section-spacing" v-if="false">
        <div class="container">
          <div class="col-12">
            <h2
              class="main-heading-1-gradient text-center"
              data-aos="fade-down"
              data-aos-duration="600"
            >
              Study Abroad - Market Growth
            </h2>
            <h5
              class="text-center"
              data-aos="fade-down"
              data-aos-duration="600"
            >
              A line to speak about featured destination or university. A line
              tospeak about featured destination,programme or univrsity
            </h5>
            <div
              class="books-wrapper d-flex justify-content-center justify-content-lg-between align-items-center flex-column flex-lg-row"
            >
              <div class="text-center text-lg-left col-md-7">
                <h3 class="font-weight-bold">Market size</h3>
                <p class="">
                  US$ 196B International Education market is set to reach $433B
                  by 2030 @7.4% cAGR
                </p>
                <h4 class="mb-1">Students Outflow</h4>
                <div class="d-flex mb-1 mobile_align" style="gap: 40px">
                  <div class="purple_background">~230K</div>
                  <div class="purple_background">~420K</div>
                </div>
                <div class="d-flex mb-1 mobile_align" style="gap: 40px">
                  <div class="purple_background">~1200K</div>
                  <div class="purple_background">~360K</div>
                </div>

                <h4 class="">
                  India higher education students - International
                </h4>
                <p>000 students, 2016,2019 and 2024</p>
              </div>
              <div class="col-md-5">
                <!-- <img
                src="../../assets/imgs/a-books.png"
                alt=""
                class="img-fluid"
              /> -->
                <img
                  src="../../assets/imgs/Market Growth.png"
                  alt=""
                  class="img-fluid custom_bar_img_height"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- <section class="py-5">
        <div class="container">
          <b-row class="row-cols-1 row-cols-lg-2 align-items-center py-4">
            <b-col>
              <img
                src="../../assets/imgs/bar-chart.png"
                alt=""
                class="img-fluid"
              />
            </b-col>
            <b-col class="mt-3 mt-lg-0">
              <h2>Market Size</h2>
              <p>
                US$ 196B International Education Market is set to reach $ 433B
                by 2030 @7.4% CAGR
              </p>
            </b-col>
          </b-row>
        </div>
      </section> -->
      <!-- <section class="py-5">
        <div class="container">
          <b-row
            class="justify-content-between align-items-center row-cols-1 row-cols-md-2"
          >
            <b-col class="text-center">
              <h4 class="mb-2">Indian Students Studying Abroad</h4>
              <img src="@/assets/imgs/indian-student-abroad-img2.png" alt="" />
              <p>Source - Ministry of Home Affairs - MOH (2022)</p>
            </b-col>
            <b-col>
              <h4>Indian Students Studying Abroad</h4>
              <img src="@/assets/imgs/donut-chart-franchise.png" alt="" />
              <p>Source - QS</p>
            </b-col>
          </b-row>
        </div>
      </section> -->
      <!-- <section class="py-5">
        <div class="container">
          <b-row class="row-cols-1 row-cols-md-2 row-cols-lg-3">
            <b-col v-for="(card, index) in flags" :key="'a' + index">
              <img :src="card.img" alt="" />
              <ul class="bullet-points p-0 pl-4 py-3">
                <li
                  v-for="(point, pointIndex) in card.list"
                  :key="pointIndex"
                  class="py-1"
                >
                  {{ point }}
                </li>
              </ul>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-center">
            <p>
              Above options are offered by world's Top 500 ranked universities.
            </p>
          </div>
        </div>
      </section> -->
      <section class="py-5" v-if="false">
        <div class="container">
          <div
            class="text-center mb-5"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <h2 class="main-heading-1-gradient text-center text-capitalize">
              our top ranking universities
            </h2>
          </div>
          <b-row class="justify-content-center py-4" style="gap: 30px">
            <b-col class="border border-1 rounded col-12 col-md-2">
              <div
                class="d-flex align-items-center gap-1 justify-content-center"
                style="padding: 26px 30px; gap: 10px"
              >
                <img
                  src="../../assets/imgs/franchise-countries/usa-mini.png"
                  alt=""
                />
                <h5 class="mb-0">USA</h5>
              </div>
            </b-col>
            <b-col class="border border-1 rounded col-12 col-md-2">
              <div
                class="d-flex align-items-center gap-1 justify-content-center"
                style="padding: 26px 30px; gap: 10px"
              >
                <img
                  src="../../assets/imgs/franchise-countries/uk-mini.png"
                  alt=""
                />
                <h5 class="mb-0">UK</h5>
              </div>
            </b-col>
            <b-col class="border border-1 rounded col-12 col-md-2">
              <div
                class="d-flex align-items-center gap-1 justify-content-center"
                style="padding: 26px 30px; gap: 10px"
              >
                <img
                  src="../../assets/imgs/franchise-countries/canada-mini.png"
                  alt=""
                />
                <h5 class="mb-0">Canada</h5>
              </div>
            </b-col>
            <b-col class="border border-1 rounded col-12 col-md-2 col-active">
              <div
                class="d-flex align-items-center gap-1 justify-content-center"
                style="padding: 26px 30px; gap: 10px"
              >
                <img
                  src="../../assets/imgs/franchise-countries/aus-mini.png"
                  alt=""
                />
                <h5 class="mb-0">Australia</h5>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <div style="height: 500px; width: 100%">
              <img
                src="../../assets/imgs/uni-top-list-img.png"
                alt=""
                class="img-fluid"
                style="object-fit: cover; height: 100%; width: 100%"
              />
            </div>
          </b-row>
        </div>
      </section>

      <!-- <section class="university-section section-spacing home-page">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div
              class="col-lg-12 text-center"
              data-aos="fade-down"
              data-aos-duration="600"
            >
              <h2 class="main-heading-1-gradient text-center">
                Our top ranking universities
              </h2>
            </div>
            <div class="col-lg-12 mt-3 pt-xl-5">
              <slick
                ref="logoSlider"
                :options="logoSlider"
                class="logo-slider"
                v-if="featured_universities.length > 0"
              >
                <div
                  v-for="(university, index) in featured_universities"
                  :key="'featured_universities_' + index"
                >
                  <div class="logo-card">
                    <div class="logo-img">
                      <img
                        :src="university[0].university_logo"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div class="logo-card">
                    <div class="logo-img">
                      <img
                        :src="university[1].university_logo"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div class="logo-card">
                    <div class="logo-img">
                      <img
                        :src="university[2].university_logo"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </slick>
            </div>
          </div>
        </div>
      </section> -->

      <!-- <section class="container" v-if="false">
        <h2
          class="main-heading-1-gradient text-center"
          data-aos="fade-down"
          data-aos-duration="600"
        >
          19+ Countries Covered
        </h2>
        <div
          class="p-lg-2 py-xl-4 row desk-m"
          style="
            font-size: 1.5rem;
            box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
            border-radius: 5px;
          "
        >
          <div class="col-md-4 pointer_section">
            <div class="d-flex align-items-center" style="gap: 10px">
              <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              />
              <h2>North America</h2>
            </div>
            <ul class="state-list">
              <li>U.S.A</li>
              <li>Canada</li>
            </ul>
          </div>

          <div class="col-md-4 pointer_section">
            <div class="d-flex align-items-center" style="gap: 10px">
              <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              />
              <h2>Europe</h2>
            </div>

            <div class="d-flex">
              <ul class="state-list">
                <li>UK</li>
                <li>Germany</li>
                <li>Switzerland</li>
                <li>France</li>
                <li>Hungary</li>
                <li>Germany</li>
              </ul>
              <ul class="state-list">
                <li>Ireland</li>
                <li>Latvia</li>
                <li>Spain</li>
                <li>Russia</li>
                <li>Georgia</li>
              </ul>
            </div>
          </div>

          <div class="col-md-4 pointer_section">
            <div class="d-flex align-items-center" style="gap: 10px">
              <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              />
              <h2>Asia & Pacific</h2>
            </div>

            <ul class="state-list">
              <li>Australia</li>
              <li>New Zealand</li>
              <li>Singapore</li>
              <li>New Zealand</li>
              <li>Malaysia</li>
            </ul>
          </div>

          <div class="col-md-4 pointer_section">
            <div class="d-flex align-items-center" style="gap: 10px">
              <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              />
              <h2>Middle East</h2>
            </div>

            <ul class="state-list">
              <li>UAE</li>
              <li>Turkey</li>
            </ul>
          </div>
        </div>
      </section> -->

      <section class="container">
        <h2
          class="main-heading-1-gradient text-center"
          data-aos="fade-down"
          data-aos-duration="600"
        >
          19+ Countries Covered
        </h2>
        <div class="row desk-m p-lg-2 py-xl-4" role="tablist">
          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button
              block
              v-b-toggle.accordion-1
              variant="info"
              class="countries_btn"
            >
              <!-- <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              /> -->
              North America
            </button>

            <!-- <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            > -->
            <b-card style="margin-top: 10px">
              <ul class="state-list">
                <li>U.S.A</li>
                <li>Canada</li>
              </ul>
            </b-card>
            <!-- </b-collapse> -->
          </b-card>

          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button
              block
              v-b-toggle.accordion-4
              variant="info"
              class="countries_btn"
            >
              <!-- <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              /> -->
              Middle East
            </button>

            <b-card style="margin-top: 10px">
              <ul class="state-list">
                <li>UAE</li>
                <li>Turkey</li>
              </ul>
            </b-card>

            <!-- <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <ul class="state-list">
                  <li>UAE</li>
                  <li>Turkey</li>
                </ul>
              </b-card-body>
            </b-collapse> -->
          </b-card>

          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button
              block
              v-b-toggle.accordion-2
              variant="info"
              class="countries_btn"
            >
              <!-- <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              /> -->
              Europe
            </button>

            <!-- <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            > -->
            <b-card style="margin-top: 10px">
              <div class="d-flex">
                <ul class="state-list">
                  <li>UK</li>
                  <li>Germany</li>
                  <li>Switzerland</li>
                  <li>France</li>
                </ul>
                <ul class="state-list">
                  <li>Ireland</li>
                  <li>Latvia</li>
                  <li>Spain</li>
                  <li>Russia</li>
                </ul>
                <ul class="state-list">
                  <li>Hungary</li>
                  <li>Georgia</li>
                </ul>
              </div>
            </b-card>
          </b-card>

          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button
              block
              v-b-toggle.accordion-3
              variant="info"
              class="countries_btn"
            >
              Asia & Pacific
            </button>

            <b-card style="margin-top: 10px">
              <ul class="state-list">
                <li>Australia</li>
                <li>New Zealand</li>
                <li>Singapore</li>
                <li>Malaysia</li>
              </ul>
            </b-card>
          </b-card>
        </div>
      </section>
      <section class="section-spacing" v-if="false">
        <img src="../../assets/imgs/city.png" alt="" class="img-fluid w-100" />
      </section>

      <section class="section-spacing" v-if="false">
        <div class="container">
          <div class="partnership-text text-center">
            <h2
              class="main-heading-1-gradient text-center mb-2"
              data-aos="fade-down"
              data-aos-duration="600"
            >
              Aliff Franchise Network
            </h2>
            <h5>Expanding rapidly...</h5>
          </div>
          <b-row class="align-items-center row-cols-1 row-cols-lg-2 py-4">
            <b-col class="text-center text-lg-left">
              <img
                src="../../assets/imgs/franchise-map-1.png"
                alt=""
                class="img-fluid"
              />
            </b-col>
            <b-col class="text-center text-lg-right">
              <img
                src="../../assets/imgs/image45.jpg"
                alt=""
                class="img-fluid"
              />
            </b-col>
          </b-row>
        </div>
      </section>

      <section>
        <div class="a-cards pb-5 text-center">
          <div class="container">
            <div
              class="text-center"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              <h2 class="main-heading-1-gradient text-center text-capitalize">
                Aliff Franchise Highlights ?
              </h2>
              <h5>
                A line to speak about featured destination, programme, or
                university.
              </h5>
            </div>
            <!-- <div
              class="row row-cols-1 row-cols-md-2 row-cols-lg-3 gap-1 py-5 justify-content-center"
            >
              <div
                class="col-3 mb-2"
                v-for="(card, index) in cards"
                :key="index"
              >
                <div class="card a-card border-0">
                  <img
                    :src="card.image"
                    alt=""
                    class="img-fluid"
                    width="40px"
                    style="margin-left: 20px;"
                  />
                  <div class="card-body text-left">
                    <h4 class="card-title font-weight-bold">
                      {{ card.title }}
                    </h4>
                    <p class="a-card-text m-0">
                      {{ card.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div> -->
            <div
              class="row row-cols-1 row-cols-md-2 row-cols-lg-3 gap-1 py-xl-5 pt-md-5"
            >
              <div
                class="col-12 col-md-6 col-lg-4 mb-2"
                v-for="(card, index) in cards"
                :key="index"
              >
                <div class="card a-card border-0" style="min-height: 100%">
                  <div
                    class="card-body text-left"
                    data-aos="fade-up"
                    data-aos-duration="600"
                  >
                    <img
                      :src="card.image"
                      alt=""
                      class="mx-auto mb-3"
                      width="50"
                    />
                    <!-- <h3 class="m-0 mb-1 text-center">{{ card.preText }}</h3> -->
                    <h3 class="card-title m-0 mb-1" style="font-weight: 900">
                      {{ card.title }}
                    </h3>
                    <p class="text-left m-0 d-none">
                      {{ card.postText }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-spacing" v-if="false">
        <div class="container">
          <b-row class="row-cols-1 row-cols-md-2 py-4">
            <b-col
              class="col-12 col-md-6 d-flex align-items-center text-center"
              style="gap: 15px"
            >
              <div
                class="bg-primary rounded-circle"
                style="width: 40px; height: 40px"
              ></div>
              <div
                class="bg-info rounded-circle"
                style="width: 40px; height: 40px"
              ></div>
              <div
                class="bg-secondary rounded-circle"
                style="width: 40px; height: 40px"
              ></div>
              <h3 class="font-weight-bold">Franchise Types</h3>
            </b-col>
            <b-col>
              <h3 class="font-weight-bold">Ideal For...</h3>
            </b-col>
          </b-row>
          <b-row class="row-cols-1 row-cols-md-2">
            <b-col style="background-color: grey; padding: 4rem">
              <div class="text-white">
                <h4><span class="pr-5">1</span>MiF - Micro Franchise</h4>
                <h4><span class="pr-5">2</span>Area Franchise</h4>
                <h4><span class="pr-5">3</span>City Master Franchise</h4>
                <h4><span class="pr-5">4</span>State Master Franchise</h4>
                <h4><span class="pr-5">5</span>Country Master Franchise</h4>
              </div>
            </b-col>
            <b-col
              class="p-5"
              style="padding: 4rem; background-color: lightgrey"
            >
              <div>
                <h4>Self Employed / WFH / SSI</h4>
                <h4>First Time Entrepreneur</h4>
                <h4>Excellent Networker & Investor</h4>
                <h4>Excellent Networker & Investor</h4>
                <h4>Excellent Networker & Investor</h4>
              </div>
            </b-col>
          </b-row>
        </div>
      </section>

      <section class="section-spacing b-car-bg">
        <div class="container">
          <div class="text-center text-white mobile_padding_title">
            <h2
              class="main-heading-1 text-center text-capitalize text-white"
              data-aos="fade-down"
              data-aos-duration="600"
            >
              Franchise Testimonials
            </h2>
            <!-- <p>
              A line to speak about featured destination, programme, or
              university. A line to speak about featured destination, programme,
              or university
            </p> -->
          </div>
          <b-row class="py-5 row-cols-1 row-cols-md-3">
            <b-col v-for="(card, index) in car_test" :key="'a' + index">
              <div
                class="text-white"
                data-aos="fade-up"
                data-aos-duration="600"
              >
                <img :src="card.img" alt="" class="img-fluid mb-2" />

                <p>{{ card.para }}</p>
                <h4
                  v-if="card.title == 'Snehas Ajgaonkar'"
                  style="visibility: hidden; margin: 0px !important"
                >
                  Hello
                </h4>
                <h4 class="">{{ card.title }}</h4>
                <h5 class="">{{ card.role }}</h5>
                <p class="">{{ card.country }}</p>
              </div>
            </b-col>
          </b-row>
        </div>
      </section>

      <section class="section-spacing">
        <div class="container">
          <div class="row">
            <div
              class="col-md-12 col-xl-6"
              data-aos="fade-right"
              data-aos-duration="500"
            >
              <img
                src="../../assets/imgs/franchise/img75.jpg"
                class="img-fluid"
              />
            </div>
            <div class="col-md-12 col-xl-6 in_center_class">
              <div
                class="text-center"
                data-aos="fade-left"
                data-aos-duration="500"
              >
                <h2
                  class="main-heading-1-gradient text-left text-capitalize mobile_padding_title text-sm-center"
                >
                  Our USP
                </h2>
              </div>
              <p class="main-content-1 pt-1 text-center">
                <img
                  src="../../assets/imgs/svgs/Title.svg"
                  class="img-fluid mb-2 mr-1"
                />

                <i class="quotes_text"
                  >Aliff brings studying abroad within the common man's reach</i
                >

                <img
                  src="@/assets/imgs/quote.svg"
                  class="img-fluid ml-1"
                  style="transform: rotate(180deg)"
                />
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section-spacing">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-xl-6 b-car-bg padding_sec">
              <div
                class="text-center"
                data-aos="fade-right"
                data-aos-duration="500"
              >
                <h2 class="main-heading-1 text-left text-capitalize text-white">
                  An AI - Powered Study Abroad EdTech Company
                </h2>
                <h2
                  class="main-heading-1 text-left text-capitalize"
                  style="color: #ffa132"
                >
                  <i>Be a Part of Transformation</i>
                </h2>
                <ul class="ai_section_pointers">
                  <li>Automated Lead Nurturing</li>
                  <li>Data Driven Recruitment</li>
                  <li>Univ Shortlisting in one second</li>
                  <li>Student Management System</li>
                  <li>75k+ courses & 460+ Univ</li>
                </ul>
              </div>
            </div>

            <div
              class="col-md-12 col-xl-6 p-0 mobile_padding_title"
              data-aos="fade-left"
              data-aos-duration="500"
            >
              <img
                src="../../assets/imgs/franchise/img81.jpg"
                class="img-fluid"
              />
              <img
                src="../../assets/imgs/franchise/img80.jpg"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="container">
        <!-- <h2 class="main-heading-1-gradient text-center mb-5">
          Awards and Recognitions
        </h2> -->
        <div class="awards-display card-columns">
          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img124.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">Salmiya (Kuwait) Franchise</div>
          </div>

          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img125.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">Lower Parel (Mumbai) Franchise</div>
          </div>
          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img126.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">
              Aliff Global Education Fair At Sofitel Hotel
            </div>
          </div>

          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img145.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">World Education Summit Award</div>
          </div>

          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img140.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">U.S Embassy & Univ Meet</div>
          </div>

          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img129.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">Vadodara (Gujarat) Franchise</div>
          </div>

          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img130.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">High School - Education Fair</div>
          </div>
          <!-- <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img150.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">Staff training by Foreign University</div>
          </div> -->

          <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img127.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">
              Meeting at Consulate General of NZ, India
            </div>
          </div>

          <!-- <div
            class="image_container"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <img
              src="@/assets/imgs/franchise/img130.jpg"
              class="img-fluid"
              alt=""
            />
            <div class="centered">High School - Education Fair</div>
          </div> -->
        </div>
        <!-- <div>
        <img src="@/assets/imgs/awards/award-13.jpg" class="img-fluid" alt="" />
      </div> -->
      </section>

      <!--About The Founder-->
      <section class="founder-section section-spacing">
        <div class="container">
          <div class="row">
            <div class="col-lg">
              <div>
                <h2
                  class="main-heading-1-gradient text-center"
                  data-aos="fade-down"
                  data-aos-duration="600"
                >
                  About the Founder
                </h2>
              </div>
            </div>
          </div>
          <div class="row mt-5 align-items-start">
            <div
              class="col-lg-4 responsive-img d-block"
              data-aos="fade-right"
              data-aos-duration="600"
            >
              <img
                src="@/assets/imgs/about-image.png"
                class="founder_img border-20"
              />
              <h1 class="font-weight-bold text-center mt-2">
                Mr. Asslam Shaikh
              </h1>
              <h2 class="primary-color pt-2 text-center">Founder & CEO</h2>
            </div>
            <div class="col-lg-8" data-aos="fade-left" data-aos-duration="600">
              <p class="main-content-1" style="text-align: left !important">
                Asslam Shaikh is a multi-award winning international education
                expert and a keynote speaker. He has over a decade of experience
                in the study abroad field & has widely travelled around the
                world. Mr. Asslam has excellent relationships with several
                embassies & consulates.

                <!-- <br />
                <img
                  src="../../assets/imgs/svgs/Title.svg"
                  class="img-fluid my-3"
                /> -->
                <!-- <br />
                <i
                  >“My passion is to help ambitious students to join top-ranking
                  international universities so that they can easily earn 6
                  figure salaries without wasting time or spending a fortune &
                  worrying about their marks"</i
                > -->
              </p>

              <p class="main-content-1" style="text-align: left !important">
                He is on various education boards & listed with professional
                bodies like US Trade Office, EU India Chamber of Commerce,
                Bombay Industries Association, Swiss India Chamber of Commerce
                to name a few.
              </p>

              <h4>Board & Industry Affiliations:</h4>
              <div
                class="row mx-1 p-3 mob_alignment_logo"
                style="border: 1px solid #0ac3a8"
              >
                <img
                  src="@/assets/imgs/franchise/UniLogo/img100.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img101.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img102.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img103.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img104.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img105.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img106.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img107.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />

                <img
                  src="@/assets/imgs/franchise/UniLogo/img108.jpg"
                  class="img-fluid col-xl-3 col-md-6 mb-1 boards_logo"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--Board f Advisor-->

      <section class="section-spacing" v-if="false">
        <div class="container">
          <h2
            class="main-heading-1-gradient text-center"
            data-aos="fade-down"
            data-aos-duration="600"
          >
            Board of Consultants
          </h2>

          <div class="row justify-content-center mt-xl-5">
            <!-- <div class="col-12 col-md-6 col-lg-4">
              <div class="text-center">
                <img
                  src="@/assets/imgs/neeraj shah.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                />
                <h4 class="bold">Neeraj Shah</h4>
                <h6
                  style="color: #2a9cce; font-weight: 600"
                  class="text-capitalize"
                >
                  Alumni Merchant Taylor's School &amp; Univ of Bath - UK Ex
                  Co-National Director - BNI India
                </h6>
              </div>
            </div> -->

            <!-- <div class="col-12 col-md-6 col-lg-4">
              <div class="text-center">
                <img
                  src="@/assets/imgs/mansoor khan.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                />
                <h4 class="bold">Mansoor Khan</h4>
                <h6
                  style="color: #2a9cce; font-weight: 600"
                  class="text-capitalize"
                >
                  Founder Director - AMFAH INDIA Regional Product Manager - BPL
                  Limited
                </h6>
              </div>
            </div> -->
            <div
              class="col-12 col-md-6 col-lg-6"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="bords_content_wrapper">
                <img
                  src="@/assets/imgs/himanshu dev.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                />
                <div class="boards_data_wrapper">
                  <h4 class="bold">Himanshu Dev</h4>
                  <h5 class="bold">High Schools&Colleges Collaborations</h5>
                  <ul class="board_li">
                    <li>Alum & Ex Lecturer North Caroline State Univ., USA</li>
                    <li>Ex Education Advisor - USA High Commission</li>
                  </ul>
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="bords_content_wrapper">
                <img
                  src="@/assets/imgs/boa-5.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow responsive_fran_mob_image"
                />
                <div class="boards_data_wrapper pl-4">
                  <h4 class="bold">Dr. Sanjay Kantharia</h4>
                  <h5 class="bold">Program Development- Health&Sciences</h5>
                  <ul class="board_li">
                    <li>MBBS & MS Orthopaedic from KEM, Mumbai.</li>
                    <li>
                      25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul>
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="bords_content_wrapper">
                <img
                  src="@/assets/imgs/zafar-khan.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                />
                <div class="boards_data_wrapper">
                  <h4 class="bold">Zafar Khan</h4>
                  <h5 class="bold">Business Strategy&Communication</h5>
                  <ul class="board_li">
                    <li>Alum of Sir J.J. School of Applied Art</li>
                    <li>Ex Managing Partner - Jawed Habib HairXpreso</li>
                    <li>Ex CEO Melstar Limited</li>
                  </ul>
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="bords_content_wrapper">
                <img
                  src="@/assets/imgs/neeraj shah.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                />
                <div class="boards_data_wrapper">
                  <h4 class="bold">Neeraj Shah</h4>
                  <h5 class="bold">Technology&Leadership</h5>
                  <ul class="board_li">
                    <li>Alum of Univ of Bath – UK</li>
                    <li>Ex Co-National Director - BNI India</li>
                    <li>Ex MD, Bonanza Rice Millers Ltd</li>
                  </ul>
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--Some of our Franchisees’ Profiles Section-->

      <section class="section-spacing">
        <div class="container">
          <h2
            class="main-heading-1-gradient text-center"
            data-aos="fade-down"
            data-aos-duration="600"
          >
            Some of our Franchises Profiles
          </h2>

          <div class="row justify-content-center mt-xl-5">
            <div
              class="col-12 col-md-6 col-lg-6"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="franchises_profile">
                <img
                  src="@/assets/imgs/franchise/RutvijJadhav-Circular.jpeg"
                  alt=""
                  class="boa-img mt-3 img_box_shadow pr-3 responsive_fran_mob_image"
                  style="width: 180px"
                />
                <div class="">
                  <h4 class="bold">Rutvij Jadhav</h4>
                  <h5 class="bold">Pune Branch</h5>
                  <h5 class="bold mt-3">
                    Alum Deakin University, AUS Retail & TeleCom Experience in
                    Australia
                  </h5>
                  <!-- <ul class="board_li">
                    <li>
                      Alum & Ex Lecturer North Caroline State Univ., USA
                    </li>
                    <li> Ex Education Advisor - USA High Commission </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6 mb-xl-5"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="franchises_profile">
                <img
                  src="@/assets/imgs/franchise/Shalini.jpg"
                  alt=""
                  class="boa-img mt-3 img_box_shadow pr-3 responsive_fran_mob_image"
                  style="width: 180px"
                />
                <div class="">
                  <h4 class="bold">Shalini Dev</h4>
                  <h5 class="bold">Dubai Branch</h5>
                  <h5 class="bold mt-3">
                    Ex School Teacher North Carolina State Univ, USA (Spouse
                    Club)
                  </h5>
                  <!-- <ul class="board_li">
                    <li> MBBS & MS Orthopaedic from KEM, Mumbai. </li>
                    <li
                      >25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="franchises_profile">
                <img
                  src="@/assets/imgs/franchise/preetiganju.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow pr-3 responsive_fran_mob_image"
                  style="width: 180px"
                />
                <div class="">
                  <h4 class="bold">Preeti Ganju</h4>
                  <h5 class="bold">Mira Road - Mumbai Branch</h5>
                  <h5 class="bold mt-3">
                    Ex AVP IDFC Securities Son studying in Switzerland
                  </h5>
                  <!-- <ul class="board_li">
                    <li>
                      Alum & Ex Lecturer North Caroline State Univ., USA
                    </li>
                    <li> Ex Education Advisor - USA High Commission </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6 mb-xl-5"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="franchises_profile">
                <img
                  src="@/assets/imgs/franchise/SnehasAjgaonkar.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow pr-3 responsive_fran_mob_image"
                  style="width: 180px"
                />
                <div class="">
                  <h4 class="bold">Snehas Ajgaonkar</h4>
                  <h5 class="bold">Lower Parel - Mumbai Branch</h5>
                  <h5 class="bold mt-3">
                    Ex Sales Head - HP & Dell Ex AVP - ProActive Ad Agency
                  </h5>
                  <!-- <ul class="board_li">
                    <li> MBBS & MS Orthopaedic from KEM, Mumbai. </li>
                    <li
                      >25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="franchises_profile">
                <img
                  src="@/assets/imgs/franchise/HeenaSalem.jpg"
                  alt=""
                  class="boa-img mt-3 img_box_shadow pr-3 responsive_fran_mob_image custom_frans_width"
                  style="width: 250px"
                />
                <div class="">
                  <h4 class="bold">Heena Salem</h4>
                  <h5 class="bold">Kuwait Branch</h5>
                  <h5 class="bold mt-3">
                    14+ Experience in Teaching & University admission centers
                  </h5>
                  <!-- <ul class="board_li">
                    <li>
                      Alum & Ex Lecturer North Caroline State Univ., USA
                    </li>
                    <li> Ex Education Advisor - USA High Commission </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-6 mb-xl-5"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="franchises_profile">
                <img
                  src="@/assets/imgs/franchise/ShabanaPathan.jpg"
                  alt=""
                  class="boa-img mt-3 img_box_shadow pr-3 responsive_fran_mob_image custom_frans_width"
                  style="width: 200px"
                />
                <div class="">
                  <h4 class="bold">Shabana Pathan</h4>
                  <h5 class="bold">Vadodara - Gujarat Branch</h5>
                  <h5 class="bold mt-3">
                    10+ Experience in Immigration & Travel business
                  </h5>
                  <!-- <ul class="board_li">
                    <li> MBBS & MS Orthopaedic from KEM, Mumbai. </li>
                    <li
                      >25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-3 d-none"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="text-center d-bock">
                <img
                  src="@/assets/imgs/franchise/preetiganju.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                  style="width: 180px"
                />
                <div class="text-cen3er">
                  <h4 class="bold mt-3 text-center">Preeti Ganju</h4>
                  <h5 class="bold text-center">Mira Road - Mumbai Branch</h5>
                  <h5 class="bold mt-3 text-center">
                    Ex AVP IDFC Securities Son studying in Switzerland
                  </h5>
                  <!-- <ul class="board_li">
                    <li> MBBS & MS Orthopaedic from KEM, Mumbai. </li>
                    <li
                      >25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-3 d-none"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="text-center d-bock">
                <img
                  src="@/assets/imgs/franchise/SnehasAjgaonkar.png"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                  style="width: 180px"
                />
                <div class="text-cen3er">
                  <h4 class="bold mt-3 text-center">Snehas Ajgaonkar</h4>
                  <h5 class="bold text-center">Lower Parel - Mumbai Branch</h5>
                  <h5 class="bold mt-3 text-center">
                    Ex Sales Head - HP & Dell Ex AVP - ProActive Ad Agency
                  </h5>
                  <!-- <ul class="board_li">
                    <li> MBBS & MS Orthopaedic from KEM, Mumbai. </li>
                    <li
                      >25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-3 d-none"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="text-center d-bock">
                <img
                  src="@/assets/imgs/franchise/HeenaSalem.jpg"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                  style="width: 180px"
                />
                <div class="text-cen3er">
                  <h4 class="bold mt-3 text-center">Heena Salem</h4>
                  <h5 class="bold text-center">Kuwait Branch</h5>
                  <h5 class="bold mt-3 text-center">
                    14+ Experience in Teaching & University admission centers
                  </h5>
                  <!-- <ul class="board_li">
                    <li> MBBS & MS Orthopaedic from KEM, Mumbai. </li>
                    <li
                      >25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-3 d-none"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div class="text-center d-block">
                <img
                  src="@/assets/imgs/franchise/ShabanaPathan.jpg"
                  alt=""
                  class="boa-img mt-3 img_box_shadow"
                  style="width: 180px"
                />
                <div class="text-center">
                  <h4 class="bold mt-3 text-center">Shabana Pathan</h4>
                  <h5 class="bold text-center">Vadodara - Gujarat Branch</h5>
                  <h5 class="bold mt-3 text-center">
                    10+ Experience in Immigration & Travel business
                  </h5>
                  <!-- <ul class="board_li">
                    <li> MBBS & MS Orthopaedic from KEM, Mumbai. </li>
                    <li
                      >25+ years experienced surgeon, having passion for
                      education
                    </li>
                  </ul> -->
                  <!-- <h6
                    style="color: #2a9cce; font-weight: 600"
                    class="text-capitalize"
                  >
                    Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                    Education Advisor - USA High Commission
                  </h6> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--Video Slider-->

      <section class="masthead hero-text-section">
        <div class="container-fluid px-0">
          <div class="hero-section">
            <div class="hero-section-container">
              <div class="content-area d-none">
                <!-- <h1 class="title">PLUG IN. PLAY YOUR FAVOURITE STREAM</h1> -->
                <h1 class="title">
                  Kickstart your dream of studying abroad with us.
                </h1>
                <!-- <p class="para">
                Your dream of studying abroad awaits you! Let’s kickstart it
                together, right now. Make us a part of your journey and let’s
                rock it!
              </p> -->
                <p class="para">We make global education affordable.</p>
                <a href="#search-home" class="hero-cta">get started</a>
              </div>
              <div class="video-area">
                <center>
                  <video autoPlay loop controls muted>
                    <source
                      src="@/assets/Clearing-Self-Doubt-Aliff-(1080p).mp4"
                      type="video/mp4"
                    />
                    Your browser does not support HTML video.
                  </video>
                </center>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr
        class="horizontal_line py-xl-1 my-5"
        data-aos="fade-down"
        data-aos-duration="600"
      />

      <section class="container">
        <div class="row">
          <div class="col-12 mb-5">
            <div class="w-100 d-flex justify-content-center">
              <a href="#form_section" class="w-50 text-center">
                <button class="main_btn_custom">Enquire Now</button>
              </a>
            </div>
          </div>
        </div>
      </section>

      <!-- NPF Form -->
      <section
        class="border d-flex flex-column align-items-center justify-content-center"
        style="height: 700px"
        v-if="false"
      >
        <h2 class="text-center py-5">Franchise Form</h2>
        <div class="d-flex justify-content-center">
          <form
            class="d-flex align-items-center flex-column p-5"
            style="width: 1000px"
            @submit.prevent="handleSubmit"
          >
            <div class="d-flex w-100">
              <b-form-input
                size="sm"
                required
                v-model="form.name"
                placeholder="Enter Name *"
                class="w-50 mr-5 rounded-0 custom-input"
              ></b-form-input>
              <b-form-input
                required
                size="sm"
                v-model="form.email"
                placeholder="Enter Email Address *"
                class="w-50 rounded-0 custom-input"
              ></b-form-input>
            </div>
            <div class="d-flex mt-4 w-100">
              <b-form-input
                required
                size="sm"
                v-model="form.mobileNumber"
                placeholder="Enter Mobile Number *"
                class="w-50 mr-5 rounded-0 custom-input"
              ></b-form-input>
              <b-form-select
                required
                size="sm"
                v-model="form.state"
                :options="stateOptions"
                class="w-50 rounded-0 custom-input"
              ></b-form-select>
            </div>
            <div class="d-flex mt-4 w-100">
              <b-form-select
                required
                size="sm"
                v-model="form.city"
                :options="cityOptions"
                class="w-50 mr-5 rounded-0 custom-input"
              ></b-form-select>
            </div>
            <div class="w-100 py-5 d-flex justify-content-center">
              <button
                type="submit"
                class="btn rounded w-50"
                style="background-color: #fe6d01; color: white"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </section>

      <!-- <section class="py-5">
        <div class="container">
          <div>
            <h2 class="main-heading-1-gradient text-center">
              Aliff - Core Team
            </h2>
          </div>
          <b-row
            class="row-cols-1 row-cols-md-2 row-cols-lg-4 justify-content-center py-5"
          >
            <b-col v-for="(card, index) in core" :key="index" class="mt-3">
              <div class="text-center">
                <img
                  :src="card.img"
                  alt=""
                  class="rounded img-fluid"
                  :width="index === 3 ? '139px' : 'auto'"
                />
                <h4 class="mt-3 font-weight-bold">{{ card.name }}</h4>
                <h6
                  style="color: #2A9CCE;font-weight: 600;"
                  class="text-capitalize"
                >
                  {{ card.designation }}
                </h6>
              </div>
            </b-col>
          </b-row>
        </div>
      </section> -->
      <!-- <section class="my-5">
        <div class="container">
          <div class="blue-strap">
            <div class="blue-bg position-absolute" style="right:0">
              <img src="@/assets/imgs/blue-strap-bg.png" alt="" />
            </div>
            <h4 class="text-white pb-4">
              Studying abroad is much easier with Aliff. <br />
              Just one call away !
            </h4>
            <div class="d-flex align-items-center" style="gap: 20px;">
              <a href="" style="color:#2A9CCE;" class="btn btn-white bg-white"
                >Book free expert counselling</a
              >
              <h5 class="text-white mb-0">
                Call us at
                <a
                  href="tel:+919987099890"
                  class="text-decoration-none text-white"
                ></a
                >+91 9987099890
              </h5>
            </div>
          </div>
        </div>
      </section> -->

      <!-- <RecentPostSection
        :recentPostsData="recentPostData['abroad-page']['data-1']"
      /> -->
    </div>
  </div>
</template>
<script>
import flag1 from "@/assets/imgs/franchise-countries/flag-1.png";
import flag2 from "@/assets/imgs/franchise-countries/flag-2.png";
import flag3 from "@/assets/imgs/franchise-countries/flag-3.png";
import flag4 from "@/assets/imgs/franchise-countries/flag-4.png";
import flag5 from "@/assets/imgs/franchise-countries/flag-5.png";
import flag6 from "@/assets/imgs/franchise-countries/flag-6.png";
import card1 from "../../assets/imgs/Hand.png";
import card2 from "../../assets/imgs/Profits.png";
import card3 from "../../assets/imgs/Capa_1.png";
import card4 from "../../assets/imgs/Support(1).png";
import card5 from "../../assets/imgs/Magnet.png";
import card6 from "../../assets/imgs/svgs/map-1.svg";
import board1 from "@/assets/imgs/board-1.png";
import core1 from "@/assets/imgs/core-1.png";
import core2 from "@/assets/imgs/core-2.png";
import core3 from "@/assets/imgs/core-3.png";
import core4 from "@/assets/imgs/core-4.jpg";
import RecentPostSection from "../partials/RecentPostSection.vue";
import slide1 from "@/assets/imgs/fran-1.png";
import slide2 from "@/assets/imgs/fran-2.png";
import slide3 from "@/assets/imgs/fran-3.png";
import homeServices from "@/apiServices/homeServices";
// import ToastificationContentVue from "@/components/extra/toastification/ToastificationContent.vue";
import { BToast } from "bootstrap-vue";
import {
  // stateOptions,
  courseOptions,
  specializationOptions,
  cityOptions,
} from "../partials/sefDetails";
import stateCity from "../partials/stateCity";
import { LMS_API } from "@/config/index";
export default {
  components: {
    BToast,
  },
  data() {
    return {
      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      featured_universities: [],
      // stateOptions,
      courseOptions,
      specializationOptions,
      cityOptions,
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      },
      flags: [
        {
          img: flag1,
          list: [
            "Top Univ fee Rs. 6 Lakhs p.a. effectively",
            "100% Accommodation Grant (Free stay)",
          ],
        },
        {
          img: flag2,
          list: [
            "MBA with 45% - save money on Foundation",
            "15% Scholarship + Paid internships",
          ],
        },
        {
          img: flag3,
          list: [
            "10% Scholarship - Admission with 50%",
            "Direct Master with 15 Yrs education (save money)",
          ],
        },
        {
          img: flag4,
          list: ["100% Scholarship for Bachelors & Masters,taught in English"],
        },
        {
          img: flag5,
          list: [
            "Upto 30% Scholarship for Hospitality & BusinessEUROPE",
            "Earn Rs. 10+ Lakh every year during study",
          ],
        },
        {
          img: flag6,
          list: [
            "Latvia Rs. 3 Lakh p.a.",
            "Hungary Rs. 5 Lakhs p.a.",
            "Ireland Rs. 8 Lakhs p.a. + work placement",
          ],
        },
      ],
      cards: [
        {
          preText: "Multiple Revenue Stream",
          title: "Multiple Revenue Stream",
          postText:
            "Save the aspirant’s money & effort through expert guidance and advanced technology support",
          image: card1,
        },
        {
          preText: "Equal",
          title: "Equal Profit sharing",
          postText: "Honest clear communication with all stakeholders",
          image: card2,
        },
        {
          preText: "Zero",
          title: "Zero capital base",
          postText:
            "About futurist courses, modern universities & favourable foreign policies",
          image: card3,
        },
        {
          preText: "Lifetime Traning & Support",
          title: "Lifetime Traning & Support",
          postText: "Showcase during any form of interaction",
          image: card4,
        },
        {
          preText: "Exclusive Territory Rights",
          title: "Exclusive Territory Rights",
          postText: "Showcase during any form of interaction",
          image: card6,
        },
        {
          preText: "Exclusive",
          title: "Lead generation support",
          postText:
            "To make every customer’s journey with Aliff enjoyable & memorable",
          image: card5,
        },
        // {
        //   preText: "Lead",
        //   title: "Generation",
        //   postText: "Support",
        //   image: card5,
        // },
      ],
      // cards: [
      //   {
      //     title: "Multiple Revenue Stream",
      //     description:
      //       "Save the aspirant’s money & effort through expert guidance and advanced technology support",
      //     image: card1
      //   },
      //   {
      //     title: "Equal Profit sharing",
      //     description: "Honest clear communication with all stakeholders",
      //     image: card2
      //   },
      //   {
      //     title: "Zero capital base",
      //     description:
      //       "About futurist courses, modern universities & favourable foreign policies",
      //     image: card3
      //   },
      //   {
      //     title: "lifetime support",
      //     description: "Showcase during any form of interaction",
      //     image: card4
      //   },
      //   {
      //     title: "Lead generation support",
      //     description:
      //       "To make every customer’s journey with Aliff enjoyable & memorable",
      //     image: card5
      //   }
      // ],
      board: [
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
      ],
      core: [
        {
          img: core1,
          name: "Jenny D’sa",
          designation: "Head - University Partnership",
        },
        {
          img: core2,
          name: "Arshad Kazi",
          designation: "Chief Technology Officer",
        },
        {
          img: core3,
          name: "Sanath Shetty",
          designation: "Head of engineering",
        },
        {
          img: core4,
          name: "Sachine Jog",
          designation: "General Manager - Franchise",
        },
      ],
      car_test: [
        {
          img: slide1,
          title: "Preeti Ganju",
          para: "“Happy to be part of award-winning Overseas Education Consultancy - Aliff. Love the support, i get 24/7 support from the team which is an added advantage for me to fulfill my work before time.”",
          country: "Mira Road, Mumbai Franchise",
          role: "Ex AVP IDFC Securities",
        },
        {
          img: slide2,
          title: "Snehas Ajgaonkar",
          para: "“Aliff, has been supportive and gave us all the insights. They are not only experienced in what they do but at the same time they train you and your team thoroughly with a lot of patience.”",
          country: "Lower Parel, Mumbai Franchise",
          role: "Ex Sales Head - HP & Dell",
        },
        {
          img: slide3,
          title: "Shalini Dev",
          para: "“Aliff has opened direct network & access to exclusive and affordable courses, unique opportunity and amazing scholarships. The right mix of personal support and technology integration at all stages is a bonus.”",
          country: "UAE, Dubai Franchise",
          role: "Ex School Teacher",
        },
      ],
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    stateOptions() {
      return stateCity.map((stateCity) => stateCity.state);
    },
    geCityOptions() {
      let currentStateCity = stateCity.find(
        (stateCity) => stateCity.state === this.form.state
      );

      this.cityOptions = currentStateCity.cities;
    },
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },
    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      };
    },
    async getData() {
      try {
        const featured_universities =
          await homeServices.getFeaturedUniversities();
        if (featured_universities.data.status) {
          const data = featured_universities.data.data;
          let temp_arr = [];
          let i = 0;
          while (i < data.length) {
            let arr = [];
            arr.push(data[i]);
            arr.push(data[i + 1]);
            arr.push(data[i + 2]);
            temp_arr.push(arr);
            i = i + 3;
          }
          this.featured_universities = temp_arr;
        }
      } catch (err) {
        console.log("Error in getting data ", err);
      }
    },
    async handleSubmit(e) {
      this.$bvToast.show("example-toast");
      try {
        e.preventDefault();

        const requestData = {
          name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          source: "franchise-enquiry-form",
          state: this.form.state,
          city: this.form.city,
        };


        const response = await axios.post(
          `${LMS_API}/form-webhook/lead`,
          requestData
        );

        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },

    async handleSubmitNewForm(e) {
      try {
        e.preventDefault();

        const requestData = {
          name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          // source: "associate-enquiry-form",
          source: "Franchise-landing-page",
          state: this.form.state,
          city: this.form.city,
        };

        // const response = await axios.post(
        //   "https://api.nopaperforms.io/lead/v1/create",
        //   requestData
        // );
        const response = await homeServices.saveSef(requestData);

        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
        }

        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  },
  components: { RecentPostSection },
};
</script>
<style>
.full-wrapper {
  margin: 5rem 0 0 0;
}
.a-card-text {
  font-size: 16px;
  color: #5b5b5b;
}
.a-hero-text h2 {
  font-family: Fira Sans;
  font-size: 70px;
  font-weight: 500;
  line-height: 84px;
  letter-spacing: 0em;
  text-align: center;
}
.img-text {
  bottom: 60px;
  left: 3.5%;
  right: auto;
  padding: 20px 35px;
  color: #fff;
  background-color: #000000a3;
  position: absolute;
}
.col-active {
  color: #fff;
  background: linear-gradient(152.24deg, #5367ff 1.16%, #00d09c 100%);
}
.a-card {
  box-shadow: 3.2259058952331543px 4.838858604431152px 12.903623580932617px 0px
    #14253f1f;
  border-radius: 15px;
  padding-top: 25px;
  /* height: 375px; */
  height: 100%;
}
.state-list {
  padding-left: 64px;
}
.franchise-col {
  margin: 25px;
  padding: 25px;
}
.blue-strap {
  background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);
  padding: 32px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
}
/* .blue-bg {
  background-image: url(@/assests/imgs/blue-strap-bg.png);
} */
.b-car-bg {
  background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);
}

.custom-input {
  border: none;
  outline: 0 !important;
  border-bottom: 1px solid lightgrey;
  box-shadow: none;
  transition: all 0.5s;
}

.custom-input:focus {
  box-shadow: none !important;
  border-bottom: 1px solid #fe6d01;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/FranchisePage.vue